import { Link } from 'react-router-dom';
import { banners, heroComics } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={banners[0].bgImage}
          alt="韩漫阅读首页背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 pt-20 pb-10">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left pt-8 lg:pt-16">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
              韩漫免费
              <span className="block text-primary-300">漫画在线观看</span>
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-lg mx-auto lg:mx-0 mb-8">
              下拉式韩国漫画大全，在线浏览各种热门韩国漫画作品，轻松又愉快的阅读体验。韩漫网站每日更新，精彩不容错过。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-book-open-line text-lg"></i>
                开始阅读
              </Link>
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full backdrop-blur-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line text-lg"></i>
                热门排行
              </Link>
            </div>
          </div>

          <div className="flex-shrink-0 flex gap-4">
            {heroComics.map((comic, idx) => (
              <Link
                key={comic.id}
                to={`/article/${comic.id}`}
                className={`group relative w-[140px] md:w-[170px] flex-shrink-0 rounded-xl overflow-hidden cursor-pointer transition-all duration-500 hover:scale-105 ${
                  idx === 0 ? 'mt-6' : idx === 2 ? 'mt-12' : 'mt-0'
                }`}
              >
                <div className="aspect-[3/4] relative">
                  <img
                    src={comic.coverImage}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top"
                    title={`${comic.title} - 韩国漫画`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-white text-sm font-medium truncate">{comic.title}</p>
                  <p className="text-white/70 text-xs">{comic.author}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}